
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('Projects', function (Parse, ProjectSchema, User) {

		// ==================================================
		// Load object schema
		// ==================================================
		let Project = ProjectSchema;


		// ==================================================
		// Methods
		// ==================================================


		/**
		 * Retrieve the list of projects
		 */
		this.list = () => {
			let query = new Parse.Query(Project);
			query.include('header_media');
			query.equalTo('live', true);
			return query.find();
		};


		/**
		 * Returns the count of all visible projects
		 */
		this.count = () => {
			let query = new Parse.Query(Project);
			query.equalTo('live', true);
			return query.count();
		}

		
		/**
		 * Retrieve a project by ID
		 */
		this.get = (id, options = {}) => {
			let query = new Parse.Query(Project);
			query.include('header_media');
			if (typeof options.include !== 'undefined') {
				query.include(options.include);
			}
			return query.get(id);
		}


		/**
		 * Retrieve projects created by the user
		 */
		this.listMine = () => {
			let query = new Parse.Query(Project);
			query.include(['header_media', 'status']);
			query.equalTo('creator', User.getCurrent());
			return query.find();
		}

	});
}




// WEBPACK FOOTER //
// ./src/app/core/services/projects.service.js